import {
  convexClient,
  crossDomainClient,
} from "@convex-dev/better-auth/client/plugins";
import { organizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { guardIdentifyUrl, sentinelClient } from "./guard/client";

const convexSiteUrl = import.meta.env.VITE_CONVEX_SITE_URL;
if (!convexSiteUrl) {
  throw new Error(
    "Missing VITE_CONVEX_SITE_URL — re-run `bunx convex dev` to populate .env.local.",
  );
}

// The Echoes Guard project that fingerprints visitors. Without the public id
// the Sentinel client is left out and nothing is sent to Guard. It is not a
// secret: it is in the URL every visitor's browser calls.
const guardPublicId = import.meta.env.VITE_GUARD_PUBLIC_ID;
const guardKvUrl = import.meta.env.VITE_GUARD_KV_URL;

/** Whether this build can identify the device to Guard. */
export const guardClientConfigured = Boolean(guardPublicId);

export const authClient = createAuthClient({
  baseURL: convexSiteUrl,
  plugins: [
    convexClient(),
    crossDomainClient(),
    organizationClient(),
    // Identifies the device and solves Sentinel's proof-of-work challenges on
    // sign-in and sign-up. It only adds request hooks.
    ...(guardPublicId
      ? [
          sentinelClient({
            identifyUrl: guardIdentifyUrl(guardPublicId, guardKvUrl),
            autoSolveChallenge: true,
          }),
        ]
      : []),
  ],
});

/**
 * Whether this browser holds anything from an earlier session. The
 * cross-domain plugin keeps the session cookie in localStorage, so this is
 * known before the first request: a visitor with nothing stored is signed
 * out, and the landing page need not wait for the session check to say so.
 */
export function mayHaveSession(): boolean {
  try {
    return Boolean(localStorage.getItem("better-auth_cookie"));
  } catch {
    return false;
  }
}
